import * as React from "react";
import ModalContact from "@radarly/components/modals/contact-manager";
import { useMember } from "@radarly/core/member/use-cases";
import {
  useContactProjectManager,
  useCurrentProject,
} from "@radarly/core/project/use-cases";
import {
  useCurrentUser,
  useCurrentUserLocale,
} from "@radarly/core/user/use-cases";
import { Project as ProjectModel } from "@radarly/models/project";

interface IProps {
  project: ProjectModel;
  close: () => void;
}

const Component = ({ project, close }: IProps) => {
  const { contactProjectManager } = useContactProjectManager(project.id);
  const projectManager = useCurrentProject()?.projectManagerId;
  const { user: manager, loading } = useMember(projectManager);
  const user = useCurrentUser();
  const locale = useCurrentUserLocale();
  return (
    <ModalContact
      contactProjectManager={(_, subject, content) => {
        contactProjectManager(subject, content);
        close();
      }}
      email={manager ? manager.email : ""}
      project={project}
      onCancel={() => close()}
      from={user.email || ""}
      locale={locale}
      loading={loading}
    />
  );
};

export default Component;
